import { render } from "./TheMenuProfessional.vue?vue&type=template&id=36a9d148&ts=true"
import script from "./TheMenuProfessional.vue?vue&type=script&lang=ts"
export * from "./TheMenuProfessional.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__